import type { ReactNode } from 'react';
import type { GovChipProps } from '@gov-design-system-ce/react';
import { GovChip } from '@gov-design-system-ce/react';

interface ChipProps extends Omit<GovChipProps, 'disabled'> {
	children: ReactNode;
	isDisabled?: boolean;
	isFocusable?: boolean;
	role?: string;
}

export const Chip = ({
	children,
	isDisabled = false,
	isFocusable,
	...props
}: ChipProps) => (
	<GovChip
		{...props}
		disabled={isDisabled}>
		{children}
	</GovChip>
);
